import { Button, Typography, Box, BDSProvider } from '@barracuda-internal/bds-core-v2';
import React, { ReactElement } from 'react';
import Grid from '@material-ui/core/Grid';
interface Props {}

function CookieSetting({}: Props): ReactElement {
	const handleCookieSettingClick = () => {
		document.getElementById('ot-sdk-btn').click();
	};


	return (
		<BDSProvider>
		<Box>
			<Typography
				variant="h3"
				color="textPrimary"
				sx={{ mb: 2 }}
			>
				Cookie Options
			</Typography>

			<Box sx={{ ml: 2, mt: 2 }}>
				<Typography
					variant="h4"
					color="textPrimary"
					sx={{ mb: 2 }}
				>
					Cookie policy confirmation
				</Typography>
			<Grid container spacing={1} style={{ marginTop: '16px', marginBottom: '32px' }}>
					<Grid item xs={3}>
						<Button
							variant="outlined"
							onClick={() => handleCookieSettingClick()}
							color="secondary"
						>
							Open Settings
						</Button>
					</Grid>
					<Grid item xs={9}>
						<Typography
							variant="body1"
							color="textPrimary"
							sx={{ mb: 2 }}
						>
							Barracuda Sites may request cookies to be set on
							your device. Open Cookie Settings to find out more,
							adjust your setings if needed and confirm your
							choice.
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Box>
		</BDSProvider>
	);
}

export default CookieSetting;
